jQuery(document).ready(function ($) {
  if($('.quote-slider').length){
    $('.quote-slider').slick({
      infinite: true,
      autoplay: true,
      autoplaySpeed: 1500,
      arrows: false,
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      adaptiveHeight: true,
      centerMode: true,
      responsive: [
        {
          breakpoint: 768, // Mobile view
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 993, // Desktop view
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            centerMode: true,
          }
        },
        {
          breakpoint: 9999, // Larger screens
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: true,
          }
        }
      ]
      //prevArrow: $('.arrow-prev-custom'),
      //nextArrow: $('.arrow-next-custom'),
    });
  }
});